export const returnFlightsHs = flightTime => {
  let resta =
    new Date(flightTime.arrival.slice(0, 10)) -
    new Date(flightTime.departure.slice(0, 10));
  let result = Math.round(resta / (1000 * 60 * 60 * 24));

  let msg = '';

  if (result > 0) {
    msg = `El vuelo llega ${result} ${
      result === 1 ? 'día' : 'días'
    } después de la salida`;
  }

  return msg;
};

export const returnDetailMsg = flight => {
  let msg = '',
    returnMsg = '';

  if (flight.stop_message) {
    msg = flight.stop_message;
  }
  if (flight.airport_change_message) {
    msg = flight.airport_change_message;
  }
  if (flight.default_message) {
    msg = flight.default_message;
  }

  let position = msg.search('-');
  returnMsg = msg.slice(0, position);
  if (returnMsg.includes('En el mismo aeropuerto')) {
    returnMsg = returnMsg.replace('En el mismo aeropuerto', '');
  }

  if (returnMsg.includes('(')) {
    returnMsg = returnMsg.replace('(', '');
  }

  if (msg.includes('En el mismo aeropuerto')) {
    returnMsg = returnMsg + '. En el mismo aeropuerto.';
  }

  if (msg.includes('parada técnica')) {
    returnMsg = returnMsg + '. Parada técnica.';
  }
  if (msg.includes('Cambio de aeropuerto - Traslado no incluido')) {
    returnMsg = returnMsg + '. Cambio de aeropuerto - Traslado no incluido.';
  }

  return returnMsg;
};

export const changeAirport = flight => {
  let isChange = false;
  flight.flights.forEach(element => {
    if (element.airport_change) isChange = true;
  });
  return isChange;
};

export const returnHorasMinutos = flightTime => {
  if (flightTime < 0) return '0 hs';

  const hours = Math.floor(flightTime / 60);
  const minutes = flightTime % 60;

  if (hours === 0) return `${minutes} min.`;
  if (minutes === 0) return `${hours} hs`;
  return `${hours} hs ${minutes} min.`;
};

export const returnOneDay = flightTime => {
  let resta =
    new Date(flightTime.arrival.slice(0, 10)) -
    new Date(flightTime.departure.slice(0, 10));

  let result = Math.round(resta / (1000 * 60 * 60 * 24));

  let msg = '';

  if (result > 0) {
    msg = ' (+' + result + ')';
  }
  return msg;
};
